import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import Utils from '../../core/Utils'
import { useTranslation } from '../../hooks/useTranslation'
import { Smartico } from '../../core/Smartico'
import './MiniGamePage.scss'

const FRAME_ID = 'mini-game-frame'

const FRAME_STYLE: React.CSSProperties = { flex: '1 1 0', minHeight: 0, width: '100%', border: 'none', display: 'block' }

const MiniGamePage = () => {
	const isMobile = Utils.isMobile()
	const [searchParams] = useSearchParams()
	const id = searchParams.get('id') ?? ''
	const navigate = useNavigate()
	const { getTexts, selectedLanguage } = useTranslation(true)

	useEffect(() => {
		if (!id) return

		let cancelled = false

		Smartico.apiReady.then(() => {
			if (!cancelled) {
				Smartico.lib().miniGame(id, { iframe: FRAME_ID, inline: true, fullscreen: true })
			}
		})

		return () => {
			cancelled = true
		}
	}, [id, selectedLanguage])

	return (
		<div className="main-content mini-game-page">
			{!isMobile && (
				<div onClick={() => navigate(-1)} className="back-button">
					<div className="icon"></div>
					{getTexts('back')}
				</div>
			)}
			<iframe key={id} id={FRAME_ID} style={FRAME_STYLE} title="Mini Game" allow="autoplay; fullscreen"></iframe>
		</div>
	)
}

export default MiniGamePage
